import { cn } from '@/app_lib/utils/utils';

interface StarProps {
  value: number;
  selected: boolean;
  rating: number;
  onClick?: () => void;
}

const Star = ({ value, rating, onClick, selected }: StarProps) => {
  const ratingRounded = Math.round(rating);
  return (
    <div className='flex items-center w-[18px] h-[18px] relative self-center text-neutrals-800'>
      {/* Full Star is grey or black */}
      {/** biome-ignore lint/a11y/useSemanticElements: @Daniel @James can you look at this */}
      <span
        className={cn('self-center absolute icon icon-star', !selected && 'text-neutrals-300')}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick?.();
          }
        }}
        role='button'
        tabIndex={0}
      />
      {/* Half star exists or not */}
      {/** biome-ignore lint/a11y/useSemanticElements: And this */}
      <span
        className={cn('self-center icon icon-half-star absolute', value > ratingRounded && 'hidden')}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick?.();
          }
        }}
        role='button'
        tabIndex={0}
      />
    </div>
  );
};

interface StarRatingProps {
  rating: number;
  setRating?: (value: number) => void;
  disabled?: boolean;
}

export const StarRating = ({ rating, setRating, disabled = true }: StarRatingProps) => {
  // biome-ignore lint/nursery/noMagicNumbers: this is how you round
  const ratingRounded = Math.round(rating / 0.5) * 0.5;
  const starCount = 5;
  return (
    <div className='flex items-center gap-2'>
      {Array.from({ length: starCount }, (_, i) => i + 1).map((value) => (
        <Star
          key={value}
          onClick={() => !disabled && setRating?.(value)}
          rating={ratingRounded}
          selected={value <= ratingRounded}
          value={value}
        />
      ))}
    </div>
  );
};
